<template>
  <teleport to="body">
    <div class="unidades-modal-overlay">
    <div class="unidades-modal-card">
      <button
        type="button"
        class="unidades-modal-close"
        @click="$emit('cerrar')"
      >
        ✕
      </button>

      <header class="unidades-modal-header">
        <div class="unidades-modal-header-main">
          <p class="unidades-modal-title">Unidades del producto</p>
          <p class="unidades-modal-subtitle">{{ tituloProducto }}</p>
        </div>

        <div class="unidades-modal-header-tools">
          <div class="unidades-modal-search">
            <input
              v-model.trim="busqueda"
              type="text"
              class="unidades-modal-search__input"
              placeholder="Buscar por serie, CI, estado, categoría, modelo o ubicación"
            />
          </div>
          <span class="unidades-modal-counter">
            {{ unidadesFiltradas.length }} / {{ unidades.length }}
          </span>
        </div>
      </header>

      <section class="unidades-modal-body">
        <div v-if="cargando" class="unidades-modal-info">
          Cargando unidades…
        </div>

        <div v-else-if="!unidades.length" class="unidades-modal-info">
          No hay unidades registradas para este producto.
        </div>

        <div v-else-if="!unidadesFiltradas.length" class="unidades-modal-info">
          No se encontraron unidades con ese filtro.
        </div>

        <div v-else class="unidades-list">
          <article
            v-for="(unidad, index) in unidadesFiltradas"
            :key="unidad.id_unidad || index"
            class="unidad-row"
          >
            <div class="unidad-row__thumb">
              <img
                v-if="imagenUnidad(unidad)"
                :src="imagenUnidad(unidad)"
                :alt="unidad.numero_serie || 'Unidad'"
                class="unidad-row__thumb-img"
              />
              <div v-else class="unidad-row__thumb-empty">
                {{ inicialUnidad(unidad) }}
              </div>
            </div>

            <div class="unidad-row__main">
              <div class="unidad-row__topline">
                <div class="unidad-row__serial-wrap">
                  <span class="unidad-row__index">#{{ index + 1 }}</span>
                  <span class="unidad-row__serial">{{ unidad.numero_serie || 'Sin número de serie' }}</span>
                </div>

                <div class="unidad-row__chips">
                  <span class="unidad-row__estado-chip" :class="estadoClass(unidad.estado)">
                    {{ unidad.estado || 'Sin estado' }}
                  </span>
                  <span class="unidad-row__meta-chip unidad-row__meta-chip--solid">
                    {{ (unidad.categoria_unidad || 'sin categoría').toUpperCase() }}
                  </span>
                  <span v-if="unidad.modelo_label" class="unidad-row__meta-chip unidad-row__meta-chip--soft">
                    {{ unidad.modelo_label }}
                  </span>
                  <span v-if="(unidad.complementos || []).length" class="unidad-row__count-chip">
                    {{ (unidad.complementos || []).length }} comp.
                  </span>
                </div>
              </div>

              <p class="unidad-row__meta">
                CI: {{ unidad.token_unidad || ('U-' + (unidad.id_unidad || index + 1)) }}
              </p>

              <div class="unidad-row__bottomline">
                <span
                  class="unidad-row__location-pill"
                  :class="{ 'unidad-row__location-pill--empty': !unidad.ubicacion_actual }"
                >
                  {{ unidad.ubicacion_actual || 'Sin ubicación' }}
                </span>

                <button
                  type="button"
                  class="unidad-row__edit-btn"
                  @click="abrirEditorUbicacion(unidad)"
                >
                  ✎
                </button>
              </div>

              <div v-if="(unidad.complementos || []).length" class="unidad-row__complements">
                <p class="unidad-row__complements-label">Complementos:</p>
                <ul class="unidad-row__complements-list">
                  <li
                    v-for="comp in unidad.complementos"
                    :key="comp.id_unidad"
                    class="unidad-row__complement-item"
                  >
                    <span class="unidad-row__complement-name">
                      {{ comp.nombre_producto || 'Complemento' }}
                    </span>
                    <span class="unidad-row__complement-serial">· {{ comp.numero_serie }}</span>
                    <span class="unidad-row__meta-chip unidad-row__meta-chip--soft unidad-row__meta-chip--inline">
                      {{ (comp.categoria_unidad || 'sin categoría').toUpperCase() }}
                    </span>
                    <span
                      v-if="comp.modelo_label"
                      class="unidad-row__meta-chip unidad-row__meta-chip--soft unidad-row__meta-chip--inline"
                    >
                      {{ comp.modelo_label }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div
      v-if="editorAbierto && unidadEditando"
      class="ubicacion-modal-overlay"
      @click.self="cerrarEditorUbicacion"
    >
      <div class="ubicacion-modal-card">
        <div class="ubicacion-modal-head">
          <div>
            <p class="ubicacion-modal-kicker">Ubicación de unidad</p>
            <h3 class="ubicacion-modal-title">{{ unidadEditando.numero_serie || 'Unidad sin serie' }}</h3>
            <p class="ubicacion-modal-subtitle">
              {{ unidadEditando.ubicacion_actual || 'Actualmente sin ubicación asignada' }}
            </p>
          </div>

          <button
            type="button"
            class="ubicacion-modal-close"
            @click="cerrarEditorUbicacion"
          >
            ✕
          </button>
        </div>

        <div class="ubicacion-modal-body">
          <SelectorUbicacionAlmacen
            :model-value="ubicacionEdicion"
            :almacenes="almacenesCatalogo"
            @update:modelValue="onUbicacionEdicionChange"
            @created="onUbicacionCreada"
          />
        </div>

        <div class="ubicacion-modal-actions">
          <button type="button" class="ubicacion-modal-btn ubicacion-modal-btn--ghost" @click="cerrarEditorUbicacion">
            Cancelar
          </button>
          <button
            type="button"
            class="ubicacion-modal-btn ubicacion-modal-btn--primary"
            :disabled="!ubicacionEdicionCompleta || guardandoUbicacion"
            @click="guardarUbicacionActual"
          >
            {{ guardandoUbicacion ? 'Guardando…' : 'Guardar ubicación' }}
          </button>
        </div>
      </div>
    </div>
    </div>
  </teleport>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import SelectorUbicacionAlmacen from '@/components/almacen/almacenes/SelectorUbicacionAlmacen.vue';

export default {
  name: 'ModalUnidadesPorProducto',
  components: {
    SelectorUbicacionAlmacen,
  },
  props: {
    producto: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      unidades: [],
      cargando: false,
      almacenesCatalogo: [],
      busqueda: '',
      editorAbierto: false,
      unidadEditando: null,
      ubicacionEdicion: {
        id_almacen: '',
        id_ubicacion_almacen: '',
      },
      guardandoUbicacion: false,
    };
  },
  computed: {
    tituloProducto() {
      return this.producto?.nombre_producto || 'Producto desconocido';
    },
    unidadesFiltradas() {
      const q = (this.busqueda || '').toString().trim().toLowerCase();
      if (!q) return this.unidades;

      return (this.unidades || []).filter((unidad) => {
        const haystack = [
          unidad.numero_serie,
          unidad.token_unidad,
          unidad.estado,
          unidad.categoria_unidad,
          unidad.modelo_label,
          unidad.ubicacion_actual,
          unidad.nombre_producto,
          ...(unidad.complementos || []).flatMap((comp) => [
            comp.numero_serie,
            comp.categoria_unidad,
            comp.modelo_label,
          ]),
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return haystack.includes(q);
      });
    },
    ubicacionEdicionCompleta() {
      return !!(this.ubicacionEdicion.id_almacen && this.ubicacionEdicion.id_ubicacion_almacen);
    },
  },
  mounted() {
    this.cargarCatalogos();
  },
  methods: {
    async cargarCatalogos() {
      this.cargando = true;
      try {
        await Promise.all([this.cargarUnidades(), this.cargarAlmacenes()]);
      } finally {
        this.cargando = false;
      }
    },
    async cargarUnidades() {
      if (!this.producto || !this.producto.id_producto) return;

      try {
        const res = await axios.get(`/api/almacen/unidades/por-producto/${this.producto.id_producto}`);
        this.unidades = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('Error al cargar unidades por producto', err);
        this.toast?.error('No se pudieron cargar las unidades del producto.');
      }
    },
    async cargarAlmacenes() {
      try {
        const { data } = await axios.get('/api/almacen/almacenes/catalogo');
        this.almacenesCatalogo = data?.data || [];
      } catch (err) {
        console.error('Error al cargar catálogo de almacenes', err);
        this.almacenesCatalogo = [];
      }
    },
    imagenUnidad(unidad) {
      return unidad?.imagen_estado_url || unidad?.imagen_principal_url || '';
    },
    inicialUnidad(unidad) {
      const texto = unidad?.numero_serie || unidad?.nombre_producto || 'U';
      return texto.toString().trim().charAt(0).toUpperCase() || 'U';
    },
    estadoClass(estado) {
      const e = (estado || '').toString().toLowerCase();
      if (['disponible', 'libre', 'almacen'].includes(e)) return 'is-available';
      if (['ocupado', 'asignado', 'prestado', 'resguardo'].includes(e)) return 'is-busy';
      if (['baja', 'deshabilitado', 'inactivo', 'merma'].includes(e)) return 'is-disabled';
      return 'is-default';
    },
    abrirEditorUbicacion(unidad) {
      this.unidadEditando = unidad;
      this.ubicacionEdicion = {
        id_almacen: unidad?.id_almacen || '',
        id_ubicacion_almacen: unidad?.id_ubicacion_almacen || '',
      };
      this.editorAbierto = true;
    },
    cerrarEditorUbicacion() {
      this.editorAbierto = false;
      this.unidadEditando = null;
      this.ubicacionEdicion = {
        id_almacen: '',
        id_ubicacion_almacen: '',
      };
      this.guardandoUbicacion = false;
    },
    onUbicacionEdicionChange(value) {
      this.ubicacionEdicion = {
        id_almacen: value?.id_almacen || '',
        id_ubicacion_almacen: value?.id_ubicacion_almacen || '',
      };
    },
    async onUbicacionCreada(payload) {
      await this.cargarAlmacenes();
      this.ubicacionEdicion = {
        id_almacen: payload?.payload?.id_almacen || this.ubicacionEdicion.id_almacen || '',
        id_ubicacion_almacen: payload?.id_ubicacion_almacen || payload?.payload?.id_ubicacion_almacen || '',
      };
    },
    async guardarUbicacionActual() {
      if (!this.unidadEditando || !this.ubicacionEdicionCompleta) {
        this.toast?.info('Selecciona una ubicación completa antes de guardar.');
        return;
      }

      this.guardandoUbicacion = true;
      try {
        await axios.post('/api/almacen/unidades/registrar-evidencia', {
          evidencias: [
            {
              id_unidad: this.unidadEditando.id_unidad,
              evento: this.unidadEditando.estado === 'almacen' ? 'ingreso' : 'resguardo',
              descripcion_estado: this.unidadEditando.descripcion_estado || '',
              id_almacen: this.ubicacionEdicion.id_almacen,
              id_ubicacion_almacen: this.ubicacionEdicion.id_ubicacion_almacen,
              observaciones: 'Ubicación actualizada desde unidades y seriales.',
            },
          ],
        });

        const ubicacionActual = this.buscarUbicacionLabel(
          this.ubicacionEdicion.id_almacen,
          this.ubicacionEdicion.id_ubicacion_almacen,
        );

        this.unidadEditando.id_almacen = this.ubicacionEdicion.id_almacen;
        this.unidadEditando.id_ubicacion_almacen = this.ubicacionEdicion.id_ubicacion_almacen;
        this.unidadEditando.ubicacion_actual = ubicacionActual;

        this.toast?.success('Ubicación actualizada correctamente.');
        this.cerrarEditorUbicacion();
      } catch (error) {
        console.error('Error al guardar ubicación de unidad:', error);
        this.toast?.error('No se pudo guardar la ubicación de la unidad.');
      } finally {
        this.guardandoUbicacion = false;
      }
    },
    buscarUbicacionLabel(idAlmacen, idUbicacion) {
      const almacen = (this.almacenesCatalogo || []).find(
        (item) => Number(item.id_almacen) === Number(idAlmacen),
      );
      const ubicacion = (almacen?.ubicaciones || []).find(
        (item) => Number(item.id_ubicacion_almacen) === Number(idUbicacion),
      );
      return ubicacion?.ubicacion_label || '';
    },
  },
};
</script>

<style scoped>
.unidades-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
  overflow-y: auto;
  background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.28), rgba(15, 23, 42, 0.95));
  backdrop-filter: blur(26px);
}

.unidades-modal-card {
  position: relative;
  width: 100%;
  max-width: 980px;
  max-height: 85vh;
  border-radius: 1.4rem;
  padding: 1rem;
  background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.28), rgba(15, 23, 42, 0.98));
  border: 1px solid rgba(148, 163, 184, 0.55);
  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.95);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.unidades-modal-close,
.ubicacion-modal-close {
  border: none;
  background: transparent;
  color: #e5e7eb;
  font-size: 0.95rem;
  cursor: pointer;
}

.unidades-modal-close {
  position: absolute;
  top: 0.45rem;
  right: 0.6rem;
  padding: 0.2rem;
}

.unidades-modal-header {
  display: flex;
  justify-content: space-between;
  gap: 0.9rem;
  align-items: flex-start;
  margin-bottom: 0.7rem;
}

.unidades-modal-header-main {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.unidades-modal-title {
  font-size: 0.9rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #cbd5f5;
}

.unidades-modal-subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: #e5e7eb;
}

.unidades-modal-header-tools {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 320px;
}

.unidades-modal-search {
  flex: 1;
}

.unidades-modal-search__input {
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(15, 23, 42, 0.7);
  color: #e2e8f0;
  padding: 0.72rem 0.95rem;
  outline: none;
}

.unidades-modal-counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  padding: 0.42rem 0.7rem;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.16);
  color: #dbeafe;
  border: 1px solid rgba(96, 165, 250, 0.25);
  font-size: 0.76rem;
  font-weight: 700;
}

.unidades-modal-body {
  margin-top: 0.2rem;
  padding-top: 0.7rem;
  padding-right: 0.35rem;
  border-top: 1px solid rgba(148, 163, 184, 0.45);
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.unidades-modal-body::-webkit-scrollbar,
.ubicacion-modal-body::-webkit-scrollbar {
  width: 8px;
}

.unidades-modal-body::-webkit-scrollbar-track,
.ubicacion-modal-body::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.35);
  border-radius: 999px;
}

.unidades-modal-body::-webkit-scrollbar-thumb,
.ubicacion-modal-body::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.65);
  border-radius: 999px;
}

.unidades-modal-info {
  font-size: 0.86rem;
  color: #e5e7eb;
  padding: 0.4rem 0.1rem;
}

.unidades-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.unidad-row {
  display: grid;
  grid-template-columns: 60px minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  padding: 0.68rem 0.75rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.88);
  border: 1px solid rgba(148, 163, 184, 0.32);
}

.unidad-row__thumb {
  width: 60px;
  height: 60px;
  border-radius: 0.95rem;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: rgba(15, 23, 42, 0.98);
}

.unidad-row__thumb-img,
.unidad-row__thumb-empty {
  width: 100%;
  height: 100%;
}

.unidad-row__thumb-img {
  object-fit: cover;
  display: block;
}

.unidad-row__thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5f5;
  font-size: 1rem;
  font-weight: 700;
}

.unidad-row__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.42rem;
}

.unidad-row__topline,
.unidad-row__bottomline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
}

.unidad-row__serial-wrap,
.unidad-row__chips {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
  min-width: 0;
}

.unidad-row__index {
  font-size: 0.7rem;
  color: #93c5fd;
  font-weight: 700;
}

.unidad-row__serial {
  color: #f8fafc;
  font-size: 0.92rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unidad-row__meta {
  font-size: 0.76rem;
  color: #94a3b8;
}

.unidad-row__estado-chip,
.unidad-row__count-chip,
.unidad-row__location-pill,
.unidad-row__meta-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.28rem 0.6rem;
  font-size: 0.72rem;
  border: 1px solid transparent;
}

.unidad-row__estado-chip.is-available {
  color: #bbf7d0;
  background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.24);
}
.unidad-row__estado-chip.is-busy {
  color: #fde68a;
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.24);
}
.unidad-row__estado-chip.is-disabled {
  color: #fecaca;
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.24);
}
.unidad-row__estado-chip.is-default,
.unidad-row__count-chip {
  color: #dbeafe;
  background: rgba(96, 165, 250, 0.12);
  border-color: rgba(96, 165, 250, 0.2);
}

.unidad-row__meta-chip--solid {
  color: #dcfce7;
  background: rgba(22, 163, 74, 0.14);
  border-color: rgba(34, 197, 94, 0.2);
  font-weight: 700;
}

.unidad-row__meta-chip--soft {
  color: #dbeafe;
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(96, 165, 250, 0.24);
}

.unidad-row__meta-chip--inline {
  padding: 0.14rem 0.46rem;
  font-size: 0.68rem;
}

.unidad-row__location-pill {
  max-width: calc(100% - 42px);
  color: #dbeafe;
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(96, 165, 250, 0.24);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unidad-row__location-pill--empty {
  color: #cbd5e1;
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.2);
}

.unidad-row__edit-btn {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.82);
  color: #dbeafe;
  cursor: pointer;
  flex: 0 0 auto;
}

.unidad-row__complements {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
}

.unidad-row__complements-label {
  font-size: 0.72rem;
  color: #94a3b8;
}

.unidad-row__complements-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.unidad-row__complement-item {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
  font-size: 0.74rem;
  color: #cbd5f5;
}

.unidad-row__complement-name {
  font-weight: 600;
}

.unidad-row__complement-serial {
  color: #94a3b8;
}

.ubicacion-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
  background: rgba(2, 6, 23, 0.72);
}

.ubicacion-modal-card {
  width: min(680px, 100%);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  border-radius: 1.2rem;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.36);
  box-shadow: 0 18px 46px rgba(15, 23, 42, 0.55);
}

.ubicacion-modal-head {
  display: flex;
  justify-content: space-between;
  gap: 0.8rem;
  align-items: flex-start;
}

.ubicacion-modal-kicker {
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #93c5fd;
}

.ubicacion-modal-title {
  margin-top: 0.15rem;
  font-size: 1rem;
  color: #f8fafc;
}

.ubicacion-modal-subtitle {
  margin-top: 0.18rem;
  font-size: 0.78rem;
  color: #94a3b8;
}

.ubicacion-modal-body {
  overflow-y: auto;
  padding-right: 0.2rem;
  flex: 1 1 auto;
  min-height: 0;
}

.ubicacion-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}

.ubicacion-modal-btn {
  border: none;
  border-radius: 999px;
  padding: 0.7rem 1rem;
  cursor: pointer;
  font-size: 0.84rem;
}

.ubicacion-modal-btn--ghost {
  background: rgba(148, 163, 184, 0.14);
  color: #e2e8f0;
}

.ubicacion-modal-btn--primary {
  background: rgba(37, 99, 235, 0.86);
  color: #eff6ff;
}

.ubicacion-modal-btn--primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 780px) {
  .unidades-modal-header {
    flex-direction: column;
  }
  .unidades-modal-header-tools {
    min-width: 0;
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .unidad-row {
    grid-template-columns: 60px minmax(0, 1fr);
  }
  .unidad-row__topline,
  .unidad-row__bottomline {
    flex-direction: column;
    align-items: flex-start;
  }
  .unidad-row__location-pill {
    max-width: 100%;
  }
}
</style>
